module.exports = __webpack_public_path__ + "assets/microsoft-clarity.8676a96b.svg";